import * as React from "react";
import { Link } from "react-router-dom";

interface ActionButtonsProps {
    submitting: boolean;
    automationIdPrefix?: string;
    onSaveClick: () => void;
    returnToListRoute: string;
}

export const ActionButtons = ({ submitting, automationIdPrefix, onSaveClick, returnToListRoute }: ActionButtonsProps) => {
    return (
        <div className="h2 pull-right">
            <button className="btn btn-primary" type="submit" disabled={submitting} onClick={onSaveClick} data-automationid={`${automationIdPrefix}_Save`}>
                Save
            </button>&nbsp;
            <Link className="btn btn-primary btn-outline" to={returnToListRoute} data-automationid={`${automationIdPrefix}_ReturnToList`}>
                Return to List
            </Link>
        </div>
    );
}
